import Examples from '@app/components/Examples'
import InviteParent from '@app/components/parents/Invite'
import Eula from '@app/components/Eula'
import Privacy from '@app/components/Privacy'
import Rules from '@app/components/Rules'

export default {
  Examples: {
    component: Examples,
    exact: true,
    path: '/examples/:id',
    layout: false
  },


  InviteParent: {
    component: InviteParent,
    exact: true,
    path: '/parent/invite'
  },

  Eula: {
    component: Eula,
    exact: true,
    path: '/eula'
  },

  Privacy: {
    component: Privacy,
    exact: true,
    path: '/privacy'
  },

  Rules: {
    component: Rules,
    exact: true,
    path: '/rules'
  }
}
